import FormDrawer from './FormDrawer.vue'
FormDrawer.install = function (Vue) {
  Vue.component(FormDrawer.name, FormDrawer)
}
export {
  FormDrawer
}
